import { miniApp, useSignal } from '@tma.js/sdk-react';

export const useAppearance = () => {
    return useSignal(miniApp.isDark) ? 'dark' : 'light';
};
